import loadingLottie from '@/public/lottie/fnf.json';
import { LoadingScreenContainer, LottieContainer } from './styles';
import { useRouter } from 'next/router';
import CircularProgress from '@mui/material/CircularProgress';
import Lottie from '@/components/@IntranetLibrary/Lottie';
import { PAGE_URL } from '@/constant/url';

type P = {
  opacity: 0 | 1;
  loop?: boolean;
};

const LoadingLottie = ({ opacity, loop = false }: P) => {
  const router = useRouter();
  const mobileMode = router.route.startsWith(PAGE_URL.HOME_MOBILE);

  return (
    <LoadingScreenContainer opacity={opacity}>
      <LottieContainer>
        {mobileMode ? (
          <CircularProgress style={{ color: 'var(--dk-text-dim, #b7bbc2)' }} />
        ) : (
          <Lottie animationData={loadingLottie} autoplay={true} loop={loop} />
        )}
      </LottieContainer>
    </LoadingScreenContainer>
  );
};

export default LoadingLottie;
